<div [style.borderColor]="color" class="divider-{{ direction }}"></div>
